import {
  ASK_ABOUT_AN_UPGRADE,
  BAND_PRACTICE_SPACE,
  BOXES_AND_SUPPLIES,
  BUDGET_BILLING,
  BUSINESS_CENTER,
  CALL_CENTER,
  CLEAN,
  CONFERENCE_ROOM,
  CONVENIENT_LOCATION,
  COVERED,
  COVERED_LOADING_BAYS,
  DRIVE_IN_LOADING_BAYS,
  DRIVE_THRU_LOADING_BAYS,
  DRIVE_UP_ACCESS,
  DRIVE_UP_LOADING_BAYS,
  DOCK_HIGH_LOADING_BAYS,
  DOLLIES_AND_HANDCARTS,
  ECO_FRIENDLY_FACILITY,
  ELEVATOR_ACCESS,
  EXCELLENT_RATING,
  EXCLUSIVE_ONLINE_RATES,
  FENCED_AND_GATED,
  FREE_EXTENDED_ACCESS_HOURS,
  FREE_EXTENDED_GATE_ACCESS,
  FRIENDLY,
  GROUND_FLOOR,
  INTERIOR_STORAGE,
  LIGHT_IN_UNIT,
  LOCAL_CHARITY_SPONSOR,
  LOW_MONTHLY_RATES,
  MISCELLANEOUS,
  MONTH_TO_MONTH_LEASE,
  MOVING_CARTS,
  MOVING_SUPPLIES_AVAILABLE,
  NEARBY_LOCATIONS,
  NO_CREDIT_CARD_REQUIRED,
  NO_CREDIT_CARDS_REQUIRED,
  NO_DEPOSIT,
  NO_DEPOSIT_REQUIRED,
  NOW_HIRING,
  OFFICE_SPACE_FOR_RENT,
  ONLINE_BILL_PAY,
  PORTABLE_STORAGE,
  QUICK_AND_EASY,
  RAMP,
  RESIDENT_MANAGER,
  RETAIL_SPACE_FOR_RENT,
  RV_AND_CAR_AND_BOAT_PARKING,
  SAFE_AND_SECURE,
  SE_HABLA_ESPANOL,
  SECURE_UNITS,
  SECURITY_CAMERA,
  SHIPPING_SERVICES,
  TEMPERATURE_CONTROLLED,
  TRUCK_RENTAL,
  TWENTY_FOUR_HOUR_ACCESS,
  TWENTY_FOUR_HOUR_ACCESS_BY_REQUEST,
  TWENTY_FOUR_HOUR_KIOSK,
  UNCOVERED,
  UPSTAIRS,
  VARIETY_OF_SIZES,
  VIDEO_SURVEILLANCE,
  WELL_LIT,
  WINE_STORAGE,
  WORKSHOPS_FOR_RENT,
} from '../../../../modules/amenities';

export { AMENITY_IDS } from '../../../../modules/amenities';

export const FALLBACK_ID = MISCELLANEOUS;

export const AMENITY_ICON_IDS = {
  [ASK_ABOUT_AN_UPGRADE]: 'ask-about-an-upgrade',
  [BAND_PRACTICE_SPACE]: 'band-practice-space',
  [BOXES_AND_SUPPLIES]: 'boxes-supplies',
  [BUDGET_BILLING]: 'low-monthly-rates',
  [BUSINESS_CENTER]: 'business-center',
  [CALL_CENTER]: 'call-center',
  [CLEAN]: 'clean',
  [CONFERENCE_ROOM]: 'conference-center',
  [CONVENIENT_LOCATION]: 'convenient-location',
  [COVERED]: 'covered-parking',
  [COVERED_LOADING_BAYS]: 'covered-loading',
  [DRIVE_IN_LOADING_BAYS]: 'covered-loading',
  [DRIVE_THRU_LOADING_BAYS]: 'covered-loading',
  [DRIVE_UP_ACCESS]: 'drive-up-access',
  [DRIVE_UP_LOADING_BAYS]: 'covered-loading',
  [DOCK_HIGH_LOADING_BAYS]: 'covered-loading',
  [DOLLIES_AND_HANDCARTS]: 'dollie-handcarts',
  [ECO_FRIENDLY_FACILITY]: 'near-campsites',
  [ELEVATOR_ACCESS]: 'elevator-access',
  [EXCELLENT_RATING]: 'excellent-rating',
  [EXCLUSIVE_ONLINE_RATES]: 'exclusive-online-discount',
  [FENCED_AND_GATED]: 'fenced-gated',
  [FREE_EXTENDED_ACCESS_HOURS]: '24-hour-access',
  [FREE_EXTENDED_GATE_ACCESS]: '24-hour-access',
  [FRIENDLY]: 'friendly',
  [GROUND_FLOOR]: 'ground-floor',
  [INTERIOR_STORAGE]: 'interior-storage',
  [LIGHT_IN_UNIT]: 'power-in-unit',
  [LOCAL_CHARITY_SPONSOR]: 'local-charity-sponsor',
  [LOW_MONTHLY_RATES]: 'low-monthly-rates',
  [MISCELLANEOUS]: 'misc',
  [MONTH_TO_MONTH_LEASE]: 'month-to-month-lease',
  [MOVING_CARTS]: 'dollie-handcarts',
  [MOVING_SUPPLIES_AVAILABLE]: 'moving-supplies-available',
  [NEARBY_LOCATIONS]: 'nearby-locations',
  [NO_CREDIT_CARD_REQUIRED]: 'no-credit-card-required',
  [NO_CREDIT_CARDS_REQUIRED]: 'no-credit-card-required',
  [NO_DEPOSIT]: 'no-deposit-required',
  [NO_DEPOSIT_REQUIRED]: 'no-deposit-required',
  [NOW_HIRING]: 'now-hiring',
  [OFFICE_SPACE_FOR_RENT]: 'trust',
  [ONLINE_BILL_PAY]: 'pay-online',
  [PORTABLE_STORAGE]: 'portable-storage',
  [QUICK_AND_EASY]: 'easy-quick',
  [RAMP]: 'ramp',
  [RESIDENT_MANAGER]: 'resident-manager',
  [RETAIL_SPACE_FOR_RENT]: 'cta-client-choice',
  [RV_AND_CAR_AND_BOAT_PARKING]: 'rv-boat-parking',
  [SAFE_AND_SECURE]: 'safe-and-secure',
  [SE_HABLA_ESPANOL]: 'espanol',
  [SECURE_UNITS]: 'secure-units',
  [SECURITY_CAMERA]: 'security-cameras',
  [SHIPPING_SERVICES]: 'shipping-services',
  [TEMPERATURE_CONTROLLED]: 'climate-control',
  [TRUCK_RENTAL]: 'truck-rental',
  [TWENTY_FOUR_HOUR_ACCESS]: '24-hour-access',
  [TWENTY_FOUR_HOUR_ACCESS_BY_REQUEST]: '24-hour-access-by-request',
  [TWENTY_FOUR_HOUR_KIOSK]: 'hour-kiosk',
  [UNCOVERED]: 'uncovered-parking',
  [UPSTAIRS]: 'upstairs',
  [VARIETY_OF_SIZES]: 'variety-of-sizes',
  [VIDEO_SURVEILLANCE]: 'video-surveillance',
  [WELL_LIT]: 'well-lit',
  [WINE_STORAGE]: 'wine-storage',
  [WORKSHOPS_FOR_RENT]: 'workshops',
};
